export const docvaultExceptions: any = {
  I000: "Acción no autorizado",
  T000: "Plantilla no encontrada.",
  F000: "Expediente no encontrado.",
  F001: "El usuario ya está asignado al expediente.",
  F002: "El usuario ya establecido como colaborador del expediente.",
  F003: "Los usuarios fuera del grupo 'operations' no pueden ser asignados a un expediente.",
  F004: "Los usuarios fuera del grupo 'cja' no pueden ser asignados como colaboradores de un expediente.",
  F005: "Los expedientes en estatus 'COMPLETADO' no pueden ser desactivados.",
  F006: "Este expediente ya tiene un multireporte o un contrato entregado y no puede ser desactivado.",
  // MB-379: una renovación desactivada no vuelve si su expediente de origen ya tiene otra.
  F007: "No se puede reactivar esta renovación: su expediente de origen ya tiene otra renovación activa. Desactiva esa primero.",
  // MB-379: el "folio anterior" tecleado al crear apunta a un expediente que ya tiene otra renovación activa.
  F008: "Ese folio anterior ya tiene otra renovación activa. Desactiva esa renovación o revisa el número.",
  BR000: "Requisito base no encontrado.",
  R000: "Requisito no encontrado.",
  RT001:
    "Este requisito ya fue validado por el equipo. Tus cambios no se guardaron; la página se actualizará para mostrar el estado más reciente.",
  RV001: "Algunos campos necesitan corrección. Revisa los campos marcados.",
  S000: "La subcarpeta no encontrada.",
  FH000: "El historial del expediente no fue encontrado.",
  ZIP000: "No se encontraron archivos para descargar",
  ZIP001: "Los archivos encontrados no pudieron ser procesados.",
};
